import React from "react";
import { HeadingWithList } from "../privacyPolicy/HeadingWithLIst";
import { Conditions } from "./Conditions";

const LISTELEMENTS: JSX.Element[] = [
  <p className="text-gray-500 pb-2" key="pp-list-1">
    <span className="font-semibold text-black">{""}</span>
    {` Abuse, harass, threaten, defame, disillusion, erode, abrogate, demean or otherwise violate the legal rights of any other person or entity;`}
  </p>,
  <div className="text-gray-500 pb-2" key="pp-list-2">
    <p className="pb-4">
      <span className="font-semibold text-black">{""}</span>
      {`Engage in any activity that interferes with or disrupts access to the Website or the services provided therein (or the servers and networks which are connected to the Website);`}
    </p>
  </div>,
  <p className="text-gray-500 pb-2 " key="pp-list-3">
    <span className="font-semibold text-black">{""}</span>
    {`Impersonate any person or entity, or falsely state or otherwise misrepresent their affiliation with a person or entity;`}
  </p>,
  <p className="text-gray-500 pb-2 " key="pp-list-4">
  <span className="font-semibold text-black">{""}</span>
  {` Publish, post, disseminate, any information which is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic, pedophilic, libelous, invasive of another's privacy, hateful, or racially, ethnically objectionable, disparaging, relating or encouraging money laundering or gambling, or otherwise unlawful in any manner whatever under any law, rule or regulation currently in force; or unlawfully threatening or unlawfully harassing including but not limited to "indecent representation of women" within the meaning of the Indecent Representation of Women (Prohibition) Act, 1986;`}
</p>,
<p className="text-gray-500 pb-2 " key="pp-list-5">
  <span className="font-semibold text-black">{""}</span>
  {` Infringe the copyright, patent or trademark of another person or legal entity;`}
</p>,

<p className="text-gray-500 pb-2 " key="pp-list-6">
  <span className="font-semibold text-black">{""}</span>
  {` Reverse engineer, disassemble, or decompile the Software and Website. The User may neither modify, rent, or resell this Software and Website for profit, nor create derivative works based upon this Website or Software.`}
</p>,
<p className="text-gray-500 pb-2 " key="pp-list-7">
  <span className="font-semibold text-black">{""}</span>
  {` Use the Website, Software or Output other than as expressly provided by the license you purchased with respect to such Website.`}
</p>,
<p className="text-gray-500 pb-2 " key="pp-list-8">
  <span className="font-semibold text-black">{""}</span>
  {` Falsely represent, expressly or by way of reasonable implication, that the Website or Software was created by you or a person other than the copyright holder of the Website and Software, namely the Website.`}
</p>,

<p className="text-gray-500 pb-2 " key="pp-list-9">
  <span className="font-semibold text-black">{""}</span>
  {` Sale or distribution of registered copies of the Website and Software is strictly forbidden.  It is a violation of this agreement to loan, rent or resell, lease, borrow, or transfer the use of registered copies of the Website.`}
</p>,
<Conditions/>
];

export const TnC = () => {
  return (
    <HeadingWithList
      heading="Terms and Conditions"
      para={<p className="text-gray-500">The User shall not use the Software or the Website to:</p>}
      headingStyles="text-gray-500 font-bold text-2xl py-4"
      listElements={LISTELEMENTS}
    />
  );
};
